import httpProvider from 'Providers/http.js'

export default {
  getServers(filters) {
    return new Promise((resolve, reject) => {
      httpProvider
        .get('/meter/server?' + new URLSearchParams(filters).toString())
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addServer(data) {
    return new Promise((resolve, reject) => {
      httpProvider
        .post('/meter/server/create', data)
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateServer(serverId, data) {
    return new Promise((resolve, reject) => {
      httpProvider
        .put('/meter/server/update/' + serverId, data)
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  removeServers(data) {
    return new Promise((resolve, reject) => {
      httpProvider
        .delete('/meter/server/delete/' + data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAccessRules(serverId) {
    return new Promise((resolve, reject) => {
      httpProvider
        .get('/meter/server/access-rules/' + serverId)
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getServerTypes() {
    return new Promise((resolve, reject) => {
      httpProvider
        .get('/meter/server-type/')
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getHealthCheck(serverId) {
    return new Promise((resolve, reject) => {
      httpProvider
        .get('/health-check/' + serverId)
        .then(response => {
          if (response.data) {
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
